import { render } from "./Objectes.vue?vue&type=template&id=321c32c7"
import script from "./Objectes.vue?vue&type=script&lang=js"
export * from "./Objectes.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__